import { staticLinks } from '@/config/routingLinks';

import IcHomeQuest from '@/components/Icons/IcHomeQuest';
import IcHelpOutside from '@/components/Icons/header/IcHelpOutside';
import IcHomeStorage from '@/components/Icons/IcHomeStorage';



export const categoryData = [
  {
    title: 'Вопросы',
    subtitle: '100+ вопросов',
    icon: <IcHomeQuest />,
    path: staticLinks.questions,
  },
  // Скрыто: Шаг за шагом
  // {
  //   title: 'Шаг за шагом',
  //   subtitle: 'Делаем новое жильё ещё более доступным',
  //   icon: <IcHelpOutside />,
  //   path: staticLinks.stepByStep,
  // },
  {
    title: 'Дальневосточная ипотека',
    subtitle: 'Льготная выдача ипотечных кредитов',
    icon: <IcHomeStorage />,
    path: staticLinks.mortgage,
  },
];

export const meta = {
  title: 'Правила выдачи ипотечного займа',
};

export const infoForBorrowers = [
  {
    title:
      'Правила выдачи ипотечных займов в АО Сахалинское ипотечное агентство с изменениям от 27.03.2020 года',
    link: 'docs/MortgageRules/pravila-vydachi-ipotechnyh-zajmov-na-stroitelstvo-izhs-dg-s-izmeneniyami-ot-23.10.2019-goda.pdf',
  },
  {
    title: 'Требование об отсрочке платежа',
    link: 'docs/MortgageRules/trebovanie-ob-otsrochke.pdf',
  },
  {
    title: 'Список документов для Заемщиков',
    link: 'docs/MortgageRules/spisok-dokumentov-dlya-zaemshhikov-24.10.19.pdf',
  },
];

export const individualBuildingData = [
  {
    title: 'Форма договора коммерческого найма',
    text: '(при соответствии критериям на право заключения договора по льготной арендной ставке)',
    link: 'docs/MortgageRules/20_compressed.pdf',
  },
  {
    title: 'Форма договора коммерческого найма',
    text: '(при НЕ соответствии критериям на право заключения договора по льготной арендной ставке)',
    link: 'docs/MortgageRules/21.pdf',
  },
];

export const easternHectareData = [
  {
    title: 'Форма договора коммерческого найма',
    text: '(при соответствии критериям на право заключения договора по льготной арендной ставке)',
    link: 'docs/MortgageRules/spisok-neobhodimyh-dokumentov-dlya-ip-s-izmeneniyami-ot-23.10.2019-g.pdf',
  },
  {
    title: 'Форма договора коммерческого найма',
    text: '(при НЕ соответствии критериям на право заключения договора по льготной арендной ставке)',
    link: 'docs/MortgageRules/spisok-neobhodimyh-dokumentov-po-programme-_-dg-24.10.19.pdf',
  },
];
